module.exports = __webpack_public_path__ + "static/media/surprised-emoji-svgrepo-com.1341f70b.svg";